import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { StatusBarStyled } from './styled';

import clsx from 'clsx';
import { ref, set } from 'firebase/database';
import Button from 'src/components/Button';
import database from 'src/libraries/firebase';

interface StatusBarProps {
  className?: string;
}

const StatusBar = ({ className }: StatusBarProps) => {
  const navigate = useNavigate();
  const robotSettingRef = ref(database, 'health_robot/setting/status');
  const [timer, setTimer] = useState(
    Math.floor(
      (new Date().getTime() - +(localStorage.getItem('timer') || 0)) / 1000,
    ),
  );

  useEffect(() => {
    let timer = setInterval(() => {
      setTimer(
        Math.floor(
          (new Date().getTime() - +(localStorage.getItem('timer') || 0)) / 1000,
        ),
      );
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <StatusBarStyled className={clsx('statusBar', className)}>
      <div className="time">{`${`${Math.floor(timer / 60)}`.padStart(
        2,
        '0',
      )}:${`${timer % 60}`.padStart(2, '0')}`}</div>
      <Button
        onClick={async () => {
          await set(robotSettingRef, 'END');
          navigate('/motion/result');
        }}
      >
        종료
      </Button>
    </StatusBarStyled>
  );
};

export default React.memo(StatusBar);
